// import piggy_bank from '../svg/pig.svg';
// import dashboard from '../img/dashboard.png';

// export default function Imagen2() {

//   return(
//     <>
//       <div className="flex h-full flex-col-reverse justify-center items-center md:flex-row md:justify-evenly mt-10 mb-10 md:mt-0 md:mb-0">
//         <div className='w-3/4 md:w-[55%] flex justify-end items-center'>
//           <p className='ml-5 md:ml-0 mb-8 md:mb-0 text-[5vw] sm:text-[4vw] md:text-[4vw] lg:text-[3.8vw] xl:text-[3.2vw] md:w-[80%] w-full'>
//             <strong className='text-[#000]'>Ahorra tiempo</strong> en tu empresa brindando tecnología a tu equipo de ventas, operación y transporte.
//           </p>
//         </div>
//         <div className='w-full md:w-[45%] flex justify-center md:justify-center items-center mt-7 md:mt-0'>
//           <img src={piggy_bank} alt="dashboard" className='flex items-center rounded-xl w-3/5 mb-7 md:mb-0 sm:w-[55%] md:w-[73%] md:h-[65%]'/>
//         </div>
//       </div>
//     </>
//   )
// }

import piggy_bank from '../svg/pig.svg';
import dashboard from '../img/dashboard.png';

export default function Imagen2() {
  return (
    <div className="w-full px-6 md:px-20 lg:px-32 bg-white">
      {/* Primera sección */}
      <div className="flex flex-col md:flex-row items-center justify-between mb-12">
        {/* Texto izquierda */}
        <div className="w-full md:w-1/2 mb-0">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-6">
            Tecnología confiable que respalda cada envío
          </h2>
          <ul className="list-disc list-outside pl-5 text-gray-700 text-base leading-relaxed space-y-2">
            <li><strong>Plataforma</strong> en la nube, disponible 24/7</li>
            <li>Cumple con el SAT de forma inmediata</li>
            <li>Tus datos están 100% protegidos</li>
            <li>Funcionamos sobre la tecnología de AWS®, de Amazon®.</li>
          </ul>
        </div>

        {/* Imagen derecha */}
        <div className="w-full md:w-1/2 flex justify-center md:justify-end">
          <img
            src={dashboard}
            alt="Dashboard"
            className="w-[80%] md:w-[70%] max-w-[550px]"
          />
        </div>
      </div>

      {/* Segunda sección */}
      <div className="flex flex-col-reverse md:flex-row items-center justify-between mb-10">
        {/* Imagen izquierda */}
        <div className="w-full md:w-1/2 flex justify-center md:justify-start">
          <img
            src={piggy_bank}
            alt="Ahorro"
            className="w-[75%] md:w-[70%] max-w-[400px]"
          />
        </div>

        {/* Texto derecha */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-4">
            Crecimiento sin más manos. Ahorra costos operando en automático.
          </h2>
          <p className="text-gray-700 text-base leading-relaxed">
            Digitaliza tu paquetería y crece sin sumar personal. Karggu automatiza lo que antes hacía tu equipo manualmente, ahorrando tiempo, dinero y esfuerzo.
          </p>
        </div>
      </div>
    </div>
  );
}